// Auto-generated from YAML files - DO NOT EDIT MANUALLY
// Run 'npm run build-data' to regenerate

import { PlanData, Company } from '../types';
import companyData from './companyData.json';

type CompanyEntry = { company: Company; years: Record<number, PlanData> };
const data = companyData as unknown as Record<string, CompanyEntry>;

/**
 * All companies, sorted by display name
 */
export const getCompanies = (): Company[] =>
  Object.values(data)
    .map(entry => entry.company)
    .sort((a, b) => a.name.localeCompare(b.name));

/**
 * Look up a company by its URL slug
 */
export const getCompany = (slug: string): Company | undefined => data[slug]?.company;

/**
 * Get all available years for a company, newest first
 */
export const getAvailableYears = (slug: string): number[] =>
  Object.keys(data[slug]?.years ?? {})
    .map(year => parseInt(year))
    .sort((a, b) => b - a);

/**
 * Get a company's plan data for a specific year
 */
export const getPlanData = (slug: string, year: number): PlanData => {
  const planData = data[slug]?.years[year];
  if (!planData) {
    throw new Error(`Plan data not available for ${slug} in ${year}. Available years: ${getAvailableYears(slug).join(', ')}`);
  }
  return planData;
};

/**
 * Get the most recent year a company has data for
 */
export const getLatestYear = (slug: string): number => getAvailableYears(slug)[0];
